import { render, staticRenderFns } from "./ViewForPurchaser.vue?vue&type=template&id=1e3f4639&lang=pug"
import script from "./ViewForPurchaser.vue?vue&type=script&lang=js"
export * from "./ViewForPurchaser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports